// extracted by mini-css-extract-plugin
module.exports = {"featureImmersiveAd":"styles_featureImmersiveAd__QerWq","featureBoxAd":"styles_featureBoxAd__Cttr2","featureInBodyAd":"styles_featureInBodyAd__y3Jrr"};